import SpainClassification from 'modules/contracts/store/models/SpainClassification'

import { PayrollLegalEntityResource } from '../payrollLegalEntityResource'

export interface IClassification {
  id: number
  legal_entity_id: number
  name: string
}

class Classifications extends PayrollLegalEntityResource<SpainClassification> {
  get cacheKey(): string {
    return 'classifications'
  }

  model() {
    return SpainClassification
  }
}

export { Classifications }
